import { render, staticRenderFns } from "./PublicFundsServices.vue?vue&type=template&id=7ea46bb7"
import script from "./PublicFundsServices.vue?vue&type=script&lang=js"
export * from "./PublicFundsServices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7ea46bb7')) {
      api.createRecord('7ea46bb7', component.options)
    } else {
      api.reload('7ea46bb7', component.options)
    }
    module.hot.accept("./PublicFundsServices.vue?vue&type=template&id=7ea46bb7", function () {
      api.rerender('7ea46bb7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/infra/purchaseService/components/sections/PublicFundsServices.vue"
export default component.exports